import { useEffect, useState } from "react";
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Swal  from "sweetalert2";
import Web3 from "web3";
import { ethers } from "ethers";
import Context from './context/context';
import { EthereumProvider } from "@walletconnect/ethereum-provider";
import Reactconnectwallet from './reactwallet/reactconnectwallet';
import { useLocation } from 'react-router-dom';
import PTGCIndex from './pages/ptgc/Index';
import PTGC_Staking from './pages/ptgc/Staking';
import PTGC_Dao from './pages/ptgc/Dao';
import PTGC_Statistics from './pages/ptgc/Statistics';
import PTGC_Onboarding from './pages/ptgc/Onboarding';
import UFOIndex from './pages/ufo/Index';  
import UFO_Pools from './pages/ufo/Pools';
import UFO_Reward from './pages/ufo/Reward';
import UFO_Statistics from './pages/ufo/Statistics';
import UFO_Onboarding from './pages/ufo/Onboarding';
import 'bootstrap/dist/css/bootstrap.min.css';
import './stylesheet/style.css';
import './stylesheet/responsive.css';
import { sendGetRequest, requestNonce, verifySignature } from './helper/Helper'; 
import ScrollToHashElement from './components/ScrollToHashElement';

function App() {
    const [pTGCVolume, setPTGCVolume] = useState({volumeDaily: 0, volumeWeekly: 0, volumeMonthly: 0, volumeQuarterly: 0, volumeSemiAnnually: 0, volumeAnnually: 0,});
    const [UFOVolume, setUFOVolume] = useState({volumeDaily: 0, volumeWeekly: 0, volumeMonthly: 0, volumeQuarterly: 0, volumeSemiAnnually: 0, volumeAnnually: 0,});
    const [ptgcPrice, setPtgcPrice] = useState(0.0);
    const [ufoPrice, setUFOPrice] = useState(0);
    const [plsPrice, setPLSPrice] = useState(0);
    const [loggedIn, setLoggedIn] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [providers, setProviders] = useState();
    const [account, setAccount] = useState();
    const [CID, setCID] = useState("");
    const [status, setStatus] = useState("");
    let provider;

    async function reactconnectwalletModal() {
        setIsOpen(true);
    }
	
   
    useEffect(() => {
        let cancelled = false;
        if (!cancelled && typeof window !== "undefined" && process.env.REACT_APP_ENV === "production" && window.location.protocol === "http:") {
            window.location.replace("https:" + window.location.href.substring(window.location.protocol.length));
        }
        return () => {
            cancelled = true;
        };
    }, []);

    async function onMetamaskConnect(){
        await setIsOpen(false);
        try {
            await window.ethereum.request({method:'eth_requestAccounts'});
            provider =  window.ethereum;
            await setProviders(provider);  
            localStorage.setItem("lastprovider", 'metamask');
            provider.on("accountsChanged", async (account) => {
                await init();
            });
            provider.on("chainChanged", (chainId) => {
                if(parseInt(chainId)  !== 369) {
                    Swal.fire({
                        title: "Error Found",
                        text: 'Make Sure You Are Using The Pulsechain Network',
                        showCancelButton: false,
                        confirmButtonText: "Ok",
                        showCloseButton: true,
                    });
                }
          });
         await init();
        } catch (e) {}
    } 

    async function onWalletConnect() {
        await setIsOpen(false);
        try {
            provider = await EthereumProvider.init({
                projectId: process.env.REACT_APP_ID,
                showQrModal: true,
                qrModalOptions: {
                    themeMode: "light",
                },
                chains: [369],
                rpcMap: {
                    369: "https://rpc.pulsechain.com",
                },
                metadata: {
                    name: 'The Grays Currency',
                    description: 'The Grays Currency',
                    url: 'https://goptgc.com',
                    icons: ['https://goptgc.com/images/logoIcon.svg']
                }
            });
            await setProviders(provider);
            localStorage.setItem("lastprovider", 'walletconnect');
            await provider.enable();
            provider.on("accountsChanged", async (account) => {
                await init();
            });
            provider.on("chainChanged", (chainId) => {
                if (parseInt(chainId)  !==  369) {
                    Swal.fire({
                        title: "Error Found",
                        text: 'Make Sure You Are Using The Pulsechain Network',
                        showCancelButton: false,
                        confirmButtonText: "Ok",
                        showCloseButton: true,
                    });
                }
            });

            await init();
        } catch (e) {}
    }

    async function onConnect() {
        setIsOpen(true);
    }

    async function onDisconnect() {
        setAccount();
        localStorage.setItem("lastprovider", ''); 
        window.location.reload();
    }

    async function init() {
        let web3 = new Web3(provider);
        let chainId = await web3.eth.getChainId();
        let account = await web3.eth.getAccounts();

        if (parseInt(chainId)  !==  369) {
            Swal.fire({
                title: "Error Found",
                text: 'Make Sure You Are Using The Pulsechain Network',
                showCancelButton: false,
                confirmButtonText: "Ok"
            });
        }
        else
        {
            const ethersProvider = new ethers.BrowserProvider(provider);
            const signer = await ethersProvider.getSigner();
            const nonceResp = await requestNonce(account[0]);

            if(nonceResp.status === 200) {
                const message = nonceResp?.data?.messageToSign;
                const signature = await signer.signMessage(message);
                const verifyResp = await verifySignature(account[0], signature);
                if(verifyResp.status === 200)
                {
                    setAccount(account[0]);
                }
                else
                {
                    Swal.fire({
                        title: "Error Found",
                        text: verifyResp.message || "Something went wrong. Please try again.",
                        showCancelButton: false,
                        confirmButtonText: "Ok"
                    }); 
                }
            }
            else {
                Swal.fire({
                    title: "Error Found",
                    text: nonceResp.message || "Something went wrong. Please try again.",
                    showCancelButton: false,
                    confirmButtonText: "Ok"
                });  
            }
        }
    }

    useEffect(() => {
        let cancelled = false;

        const fetchHistoricalVolumeData = async () =>  {
            const pTGCResponse = await sendGetRequest('historical-data');
            if (!cancelled && pTGCResponse && pTGCResponse.status === 200) {
                setPTGCVolume({
                    volumeDaily: parseFloat(pTGCResponse.data.day1).toFixed(0),
                    volumeWeekly: parseFloat(pTGCResponse.data.week1).toFixed(0),
                    volumeMonthly: parseFloat(pTGCResponse.data.month1).toFixed(0),
                    volumeQuarterly: parseFloat(pTGCResponse.data.days90).toFixed(0),
                    volumeSemiAnnually: parseFloat(pTGCResponse.data.days180).toFixed(0),
                    volumeAnnually: parseFloat(pTGCResponse.data.yearly).toFixed(0)
                });
                setPtgcPrice(parseFloat(pTGCResponse.data.ptgc_price));
                setCID(pTGCResponse.data.cid);
            }

            const UFOResponse = await sendGetRequest('ufo/historical-data');
            if (!cancelled && UFOResponse && UFOResponse.status === 200) {
                setUFOVolume({
                    volumeDaily: parseFloat(UFOResponse.data.day1).toFixed(0),
                    volumeWeekly: parseFloat(UFOResponse.data.week1).toFixed(0),
                    volumeMonthly: parseFloat(UFOResponse.data.month1).toFixed(0),
                    volumeQuarterly: parseFloat(UFOResponse.data.days90).toFixed(0),
                    volumeSemiAnnually: parseFloat(UFOResponse.data.days180).toFixed(0),
                    volumeAnnually: parseFloat(UFOResponse.data.yearly).toFixed(0)
                });
                setUFOPrice(parseFloat(UFOResponse.data.ufo_price));
            }

            const plsResponse = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=pulsechain&vs_currencies=usd');
            const plsData = await plsResponse.json();
            if (!cancelled) {
                setPLSPrice(plsData?.pulsechain?.usd);
            }
        };

        fetchHistoricalVolumeData();

        return () => {
            cancelled = true;
        };
    }, []);

  return (
    <>  
     <Context.Provider value={{account, onConnect, providers, pTGCVolume, UFOVolume, ptgcPrice, ufoPrice, plsPrice, onDisconnect, CID}}>
      <Router>
        <ScrollToHashElement />
        <Routes>
          <Route path='/' element={<PTGCIndex />} />  
          <Route path='/ptgc' element={<PTGCIndex />} /> 
          <Route path='/ptgc-staking' element={<PTGC_Staking />} />  
          <Route path='/ptgc-dao' element={<PTGC_Dao />} />   
          <Route path='/ptgc-statistics' element={<PTGC_Statistics />} /> 
          <Route path='/ptgc-onboarding' element={<PTGC_Onboarding />} /> 
          {
            /*
                <Route path='/ufo' element={<UFOIndex />} />  
              <Route path='/ufo-pools' element={<UFO_Pools />} />  
              <Route path='/ufo-reward' element={<UFO_Reward />} />  
              <Route path='/ufo-statistics' element={<UFO_Statistics />} />
              <Route path='/ufo-onboarding' element={<UFO_Onboarding />} /> 
            */
          }
        </Routes>
      </Router>
      </Context.Provider>
     <Reactconnectwallet onWalletConnect={onWalletConnect} onMetamaskConnect={onMetamaskConnect} modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}  />
    </>
  );
}

export default App;